import { FC } from 'react';
import { Skeleton } from '../ui/Skeleton';
import styles from './index.module.scss';

const SkeletonCard: FC = () => {
    return (
        <div className={styles.skeletonCard}>
            <Skeleton className={styles.skeletonImage}></Skeleton>
            <div className={styles.skeletonInfo}>
                <Skeleton height="14px" width="80%"></Skeleton>
                <Skeleton height="14px" width="40px"></Skeleton>
            </div>
        </div>
    );
};

export default SkeletonCard;
